import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'

import { getApplicationLocaleCode } from '~/locales'

import { useCurrentUserQuery } from './useCurrentUserQuery'

export const useCurrentUserLanguage = () => {
  const { isAuthenticated } = useAuth0()
  const { data, isLoading } = useCurrentUserQuery({ enabled: isAuthenticated })

  return React.useMemo(() => {
    const language = data?.language?.code ?? getApplicationLocaleCode()

    return {
      isLoading: isAuthenticated ? isLoading : false,
      language,
    }
  }, [data, isAuthenticated, isLoading])
}
